import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "flex-fill" }
const _hoisted_3 = { class: "pt-2 pb-2 d-flex w-100" }
const _hoisted_4 = { class: "flex-fill text-truncate" }
const _hoisted_5 = {
  key: 0,
  class: "pl-2"
}
const _hoisted_6 = ["textContent", "onClick"]
const _hoisted_7 = { class: "table table-hover m-0" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "text-truncate" }

import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import ElCardSectionWithTable from "~/cabinet/vue/interface/card/ElCardSectionWithTable.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import StickyCard from "~/cabinet/vue/interface/card/StickyCard.vue";
import OperatorApplicationHtmlify from "~/operatorApplication/vue/misc/OperatorApplicationHtmlify.vue";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import {computed, onMounted, ref, watch} from "vue";
import SendArticlePayloadInterface, {
    SendGroupPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/knowledgeBase/SendArticlePayloadInterface";
import {__} from "~/ts/library/Translate";
import {TreeInstance} from "element-plus";

interface ElemeTreeElement {
    id: string;
    label: string;
    children?: ElemeTreeElement[];
    color?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'KnowledgeBaseDialog',
  props: /*@__PURE__*/_mergeModels({
    knowledgeBaseList: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["send-article", "send-group"], ["update:visible"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit

let isVisible = _useModel<boolean>(__props, "visible");
function close() {
    isVisible.value = false;
}

let treeComponent = ref<TreeInstance>();
let selectedKnowledgeBaseId = ref<string>();
let filterText = ref<string>();
let tree = ref<OperatorApplicationApi.OperatorKnowledgeBaseGroupOpenApiModel>();

let articleDialog = ref<{
    visible: boolean,
    articleId: string,
    registerId: string,
    article: OperatorApplicationApi.OperatorKnowledgeBaseGetArticleResultOpenApiModel
}>();

function applyFilter() {
    if (treeComponent.value) {
        treeComponent.value.filter(filterText.value?.toLowerCase());
    }
}

watch(filterText, () => applyFilter());

let selectedKnowledgeBase = computed(() => {
    let result = props.knowledgeBaseList.find(item => item.id == selectedKnowledgeBaseId.value);
    if (!result && props.knowledgeBaseList.length == 1) {
        result = props.knowledgeBaseList[0];
    }
    return result;
});

async function onSelectedKnowledgeBaseChange() {
    tree.value = null;
    if (selectedKnowledgeBase.value) {
        let p: OperatorApplicationApi.OperatorKnowledgeBaseGetTreeOpenApiModel = {
            registerId: selectedKnowledgeBase.value.id
        };
        try {
            let result = await (new OperatorApiRequest<any>({
                url: "/knowledgeBase/getTree",
                p
            })).send();
            if (result.isSuccess) {
                let data: OperatorApplicationApi.OperatorKnowledgeBaseGetTreeResultOpenApiModel = result.data;
                if (selectedKnowledgeBase.value?.id == p.registerId) {
                    tree.value = data.tree;
                }
            }
        } catch (e) {

        }
    }
}

watch(selectedKnowledgeBase, () => onSelectedKnowledgeBaseChange());

onMounted(() => {
    if (selectedKnowledgeBase.value) {
        onSelectedKnowledgeBaseChange();
    }
});


function setSelectedKnowledgeBase(base?: OperatorApplicationApi.OperatorGetParamsSiteKnowledgeBaseOpenApiModel) {
    selectedKnowledgeBaseId.value = base ? base.id : null;
}

let treeForEleme = computed(() => {
    if (tree.value) {
        let treeArray: ElemeTreeElement[] = [];
        convertGroupToEleme(tree.value, treeArray);
        return treeArray;
    } else {
        return null;
    }
});

function convertGroupToEleme(group: OperatorApplicationApi.OperatorKnowledgeBaseGroupOpenApiModel, tree: ElemeTreeElement[]) {
    for (let childGroup of group.groups) {
        let item: ElemeTreeElement = {
            id: childGroup.id,
            label: childGroup.descr,
            children: []
        };
        convertGroupToEleme(childGroup, item.children);
        tree.push(item);
    }
    for (let article of group.articles) {
        tree.push({
            id: article.id,
            label: article.descr,
            color: article.color
        });
    }
}

async function handleNodeClick(node: ElemeTreeElement) {
    if (!node.children) {
        let p: OperatorApplicationApi.OperatorKnowledgeBaseGetArticleOpenApiModel = {
            articleId: node.id,
            registerId: selectedKnowledgeBase.value.id
        };
        let result = await (new OperatorApiRequest<any>({
            url: "/knowledgeBase/getArticle",
            p
        })).send();
        if (!result.showMessageOnError()) {
            let data: OperatorApplicationApi.OperatorKnowledgeBaseGetArticleResultOpenApiModel = result.data;
            articleDialog.value = {
                visible: true,
                article: data,
                articleId: p.articleId,
                registerId: p.registerId
            };
        }
    }
}

function n(node: ElemeTreeElement): ElemeTreeElement {
    return node;
}

function filterNode(value: string, data: ElemeTreeElement) {
    if (!value) return true;
    return data.label.toLowerCase().indexOf(value) > -1;
}

function sendArticleToClient(registerId: string, articleId: string, descr: string) {
    let payload: SendArticlePayloadInterface = {
        articleId,
        registerId,
        descr
    };
    emits("send-article", payload);
    articleDialog.value = null;
    close();
}

function sendGroupToClient(node: ElemeTreeElement) {
    let payload: SendGroupPayloadInterface = {
        groupId: node.id,
        registerId: selectedKnowledgeBase.value.id,
        descr: node.label
    };
    emits("send-group", payload);
    close();
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (__props.knowledgeBaseList.length)
    ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
        title: _unref(selectedKnowledgeBase) ? _unref(selectedKnowledgeBase).descr : _unref(__)('База знаний'),
        class: _normalizeClass({
            'right w-50 overflow full-height-body knowledge-base-dialog': true,
            'no-padding': _unref(selectedKnowledgeBase)
        }),
        "close-on-press-escape": ""
      }, {
        default: _withCtx(() => [
          (_unref(selectedKnowledgeBase))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(StickyCard, { style: {"border-left":"0","border-top":"0","border-right":"0"} }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", null, [
                        (__props.knowledgeBaseList.length > 1)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (setSelectedKnowledgeBase(null))),
                              class: "mr-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, { icon: "reply" })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_el_input, {
                          placeholder: _unref(__)('Поиск'),
                          modelValue: _unref(filterText),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filterText) ? (filterText).value = $event : filterText = $event))
                        }, null, 8, ["placeholder", "modelValue"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                (_unref(treeForEleme))
                  ? (_openBlock(), _createBlock(_component_el_tree, {
                      key: 0,
                      data: _unref(treeForEleme),
                      class: "tree",
                      ref_key: "treeComponent",
                      ref: treeComponent,
                      onNodeClick: handleNodeClick,
                      "filter-node-method": filterNode,
                      "default-expand-all": ""
                    }, {
                      default: _withCtx(({node, data}) => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(FontAwesomeIcon, {
                              icon: n(data).children ? 'folder' : 'file-alt',
                              style: _normalizeStyle({color: n(data).color}),
                              class: "mr-1"
                            }, null, 8, ["icon", "style"]),
                            _createTextVNode(" " + _toDisplayString(n(data).label), 1)
                          ]),
                          (n(data).children && _unref(selectedKnowledgeBase)?.isAvailableForSendToClient)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("a", {
                                  tabindex: "",
                                  class: "link-dashed",
                                  textContent: _toDisplayString(_unref(__)('Отправить группу')),
                                  onClick: _withModifiers(($event: any) => (sendGroupToClient(n(data))), ["stop"])
                                }, null, 8, _hoisted_6)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["data"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createBlock(_component_el_card, {
                key: 1,
                class: "no-shadow"
              }, {
                default: _withCtx(() => [
                  _createVNode(ElCardHeader, {
                    title: _unref(__)('Выберите базу знаний')
                  }, null, 8, ["title"]),
                  _createVNode(ElCardSectionWithTable, null, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_7, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.knowledgeBaseList, (item) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.id,
                              class: "cursor-pointer"
                            }, [
                              _createElementVNode("td", {
                                onClick: ($event: any) => (setSelectedKnowledgeBase(item))
                              }, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, _toDisplayString(item.descr), 1)
                                ])
                              ], 8, _hoisted_8)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
          (_unref(articleDialog) && _unref(articleDialog).visible)
            ? (_openBlock(), _createBlock(MyDialog, {
                key: 2,
                title: _unref(articleDialog).article.descr,
                visible: _unref(articleDialog).visible,
                "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(articleDialog).visible) = $event)),
                "close-on-press-escape": "",
                "show-standart-buttons": _unref(selectedKnowledgeBase)?.isAvailableForSendToClient,
                "button-text": _unref(__)('Отправить клиенту'),
                dialog: {
                width: '800px',
                class: 'overflow sticky-footer'
            },
                onApply: _cache[3] || (_cache[3] = ($event: any) => (sendArticleToClient(_unref(articleDialog).registerId, _unref(articleDialog).articleId, _unref(articleDialog).article.descr)))
              }, {
                default: _withCtx(() => [
                  _createVNode(OperatorApplicationHtmlify, {
                    value: _unref(articleDialog).article.html,
                    escape: false
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["title", "visible", "show-standart-buttons", "button-text"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "title", "class"]))
    : _createCommentVNode("", true)
}
}

})